import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('voice-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.455 5.508c.44.057.783.219.983.536.264.412.44.873.516 1.355.097.539.146 1.052.15 1.566v30.593c-.006.49-.089.975-.245 1.44a2.543 2.543 0 0 1-.746 1.17 1.41 1.41 0 0 1-.864.331c-.891-.136-1.529-.45-2.005-.955a273.937 273.937 0 0 0-4.196-3.711 391.047 391.047 0 0 0-4.036-3.48 608.466 608.466 0 0 0-4.426-3.663c-.15.01-.335.02-.581.033-.585.033-.828.046-1.071.046h-.672a2.007 2.007 0 0 1-1.469-.558 1.715 1.715 0 0 1-.542-1.265V19.36a2.06 2.06 0 0 1 .59-1.517c.372-.387.89-.598 1.429-.584h2.29a992.25 992.25 0 0 1 6.429-5.351c.82-.687 1.625-1.353 2.4-1.988.784-.64 1.506-1.234 2.134-1.758.62-.518 1.168-.971 1.596-1.324.548-.449.704-.572.78-.628.502-.417 1.014-.64 1.556-.703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.75 19.5c1.333 1.333 2 2.833 2 4.5 0 1.667-.667 3.333-2 5M37.75 13.5c4 2.333 6 5.833 6 10.5s-2 8.333-6 11",
    strokeLinecap: props.strokeLinecap
  })));
});